import React, { useContext, useEffect, useState } from "react";
import Grid from "@mui/material/Grid";
import MDBox from "components/MDBox";
import MDInput from "components/MDInput";
import MDSelectBox from "components/MDSelectBox";
import { useFormik } from "formik";
import { ModalContext } from "context/ModalContext";
import PropTypes from "prop-types";
import { LoginFormContext } from "context/LoginFormContext";
import ImageUploader from "components/MDImageUploader";
import { initialValues, updateInitialValues } from "./schemas/initialValue";
import { validationSchema } from "./schemas/validation";
import { statusData } from "helpers/constant";
import SubmitButton from "components/SubmitButton";
import { addQrTemplateApi } from "Apis/qrTemplate";
import { QrTemplateContext } from "context/QrTemplateContext";
import { updateQrTemplateApi } from "Apis/qrTemplate";
import { textValidationSchema } from "./schemas/validation";
import CloseIcon from "@mui/icons-material/Close";
import { Box, Button, CircularProgress, Modal, Typography } from "@mui/material";
import QRCode from "qrcode";
import MDTypography from "components/MDTypography";

const QrTemplateForm = ({ getQrTemplateList }) => {
  const { editData } = useContext(QrTemplateContext);
  const { setNotification, profileImage, setProfileImage } = useContext(LoginFormContext);
  const [status, setStatus] = useState({
    label: "Active",
    value: "1",
  });
  const [isTempView, setIsTempView] = useState(false);
  const [previewImage, setPreviewImage] = useState(null);
  const [isGenerating, setIsGenerating] = useState(false);
  const { setOpen, formIsEdit } = useContext(ModalContext);
  // const [isDisplayQr, setIsDisplayQr] = useState(false);

  const setDataInFormik = async () => {
    formik.setValues(editData);
    formik.setFieldValue("image", editData?.qr_templates_images?.image.split("/").pop());
    // formik.setFieldValue("is_show_member_id", editData?.is_show_member_id);
    // setIsDisplayQr(editData?.is_show_member_id === 1 ? true : false);
    setProfileImage({
      url: editData?.qr_templates_images?.image || null,
      name: null,
    });
  };

  const getStatusLabel = (id) => {
    const status = statusData.find((item) => item.value == id);
    return status ? status.label : "";
  };

  useEffect(() => {
    if (formIsEdit) {
      setDataInFormik();
      setStatus({ label: getStatusLabel(editData?.is_active), value: editData?.is_active });
    } else if (formIsEdit === false) {
      setProfileImage({
        url: null,
        name: null,
      });
    }
  }, []);

  const handleSubmit = async (values) => {
    const payload = {
      ...values,
      // text_x: isDisplayQr ? values?.text_x : 0,
      // text_y: isDisplayQr ? values?.text_y : 0,
    };
    delete payload.temp_image;
    delete payload.qr_templates_images;

    if (!formIsEdit) {
      let response = await addQrTemplateApi(payload);
      if (response?.status === 200) {
        getQrTemplateList();
        setOpen(false);
        setNotification({
          color: "success",
          icon: "check",
          title: "Success",
          content: response?.data?.message,
          open: true,
        });
      }
    } else {
      let response = await updateQrTemplateApi(payload);
      if (response?.status === 200) {
        getQrTemplateList();
        setNotification({
          color: "success",
          icon: "check",
          title: "Success",
          content: response?.data?.message,
          open: true,
        });
        setOpen(false);
      } else {
        setNotification({
          color: "error",
          icon: "cancel",
          title: "Error",
          content: response?.data?.message,
          open: true,
        });
      }
    }
  };

  const handleStatusChange = (value) => {
    if (value) {
      formik.setFieldValue("is_active", value.value);
      setStatus(value);
    } else {
      formik.setFieldValue("is_active", null);
      setStatus(null);
    }
  };

  const generateQRPreview = async () => {
    if (!profileImage?.url) {
      setNotification({
        color: "warning",
        icon: "warning",
        title: "Warning",
        content: "Please upload a template image first",
        open: true,
      });
      return;
    }

    const qrSize = formik.values.desk_qr_size || 400;
    const qrX = formik.values.desk_qr_x || 0;
    const qrY = formik.values.desk_qr_y || 0;
    const textX = formik.values.text_x || 0;
    const textY = formik.values.text_y || 0;
    const data = { ticket_id: "1759822398949D804" };
    const qrBaseString = JSON.stringify(data);

    setIsGenerating(true);
    setIsTempView(true);

    try {
      // Generate QR code
      const qrCodeUrl = await QRCode.toDataURL(qrBaseString, {
        width: qrSize,
        margin: 1,
        color: {
          dark: "#000000",
          light: "#FFFFFF",
        },
      });

      // Load template image
      const templateImg = new Image();
      templateImg.crossOrigin = "anonymous";
      await new Promise((resolve, reject) => {
        templateImg.onload = resolve;
        templateImg.onerror = reject;
        templateImg.src = profileImage.url;
      });

      // Create canvas
      const canvas = document.createElement("canvas");
      canvas.width = templateImg.width;
      canvas.height = templateImg.height;
      const ctx = canvas.getContext("2d");

      // Draw template image
      ctx.drawImage(templateImg, 0, 0);

      // Load QR code image
      const qrImg = new Image();
      await new Promise((resolve, reject) => {
        qrImg.onload = resolve;
        qrImg.onerror = reject;
        qrImg.src = qrCodeUrl;
      });

      // Draw QR code at specified position
      ctx.drawImage(qrImg, qrX, qrY, qrSize, qrSize);

      // Draw text if Member Only is enabled
      // if (isDisplayQr) {
      const sampleText = "";
      ctx.font = "bold 30px Arial";
      ctx.fillStyle = "#000000";
      ctx.textAlign = "left";
      ctx.textBaseline = "top";
      ctx.fillText(sampleText, textX, textY);
      // }

      // Convert canvas to image
      const previewDataUrl = canvas.toDataURL("image/png");
      setPreviewImage(previewDataUrl);
    } catch (error) {
      console.error("Error generating preview:", error);
      setNotification({
        color: "error",
        icon: "error",
        title: "Error",
        content: "Failed to generate preview: " + error.message,
        open: true,
      });
    } finally {
      setIsGenerating(false);
    }
  };

  const handleClosePreview = () => {
    setIsTempView(false);
    setPreviewImage(null);
  };

  //Formik
  const formik = useFormik({
    initialValues: !formIsEdit ? initialValues : updateInitialValues,
    validationSchema: validationSchema,
    onSubmit: handleSubmit,
    enableReinitialize: true,
  });

  return (
    <>
      <MDBox component="form" role="form" onSubmit={formik.handleSubmit}>
        <Grid container spacing={2} rowSpacing={1} columnSpacing={{ xs: 1, sm: 2, md: 3 }}>
          {/* Image */}
          <Grid item xs={12} md={12} sx={{ paddingTop: "20px !important" }}>
            <ImageUploader
              img={profileImage.url}
              folderName="qr_templates"
              fileName={"image"}
              name={"image"}
              formik={formik}
              label="Qr Template Image"
              sx={{
                width: "100px",
                height: "100px",
                objectFit: "cover",
                borderRadius: "50%",
                marginBottom: "16px",
              }}
              required
            />
            {formik.touched.image && formik.errors.image && (
              <MDBox
                component="p"
                sx={{
                  fontSize: "12px",
                  marginLeft: "5px",
                  color: "red",
                }}
              >
                {formik.errors.image}
              </MDBox>
            )}
          </Grid>
          <Grid item xs={12} md={12} sx={{ paddingTop: "10px !important" }}>
            <Button
              variant="outlined"
              size="medium"
              onClick={generateQRPreview}
              disabled={!profileImage?.url || isGenerating}
              startIcon={isGenerating ? <CircularProgress size={20} color="inherit" /> : null}
              sx={{
                gap: "10px",
                margin: "20px 0px",
                minWidth: "129px",
                color: "#a68181",
                backgroundColor: ` info.main`,
              }}
            >
              {isGenerating ? "Generating Preview..." : "Desktop Preview with QR Code"}
            </Button>
          </Grid>
          {/* <Grid item xs={12} md={12} sx={{ paddingTop: "30px !important" }}>
            <SingleCheckbox
              xs={12}
              md={6}
              name="is_show_member_id"
              label="Member Only"
              onChange={(event) => handleIsDisplayQR(event)}
              onBlur={formik.handleBlur}
              checked={isDisplayQr}
            />
          </Grid> */}
          <Grid item xs={12} md={6} sx={{ marginTop: "10px" }}>
            <MDInput
              type="text"
              name="title"
              value={formik.values.title}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              sx={{ width: "100%" }}
              label="Title"
              variant="standard"
              required
            />
            {formik.touched.title && formik.errors.title && (
              <MDBox sx={{ fontSize: "12px", color: "red", marginTop: "5px" }}>
                {formik.errors.title}
              </MDBox>
            )}
          </Grid>
          <Grid item xs={12} md={6} sx={{ marginTop: "10px" }}>
            <MDInput
              type="text"
              name="qr_base_string"
              value={formik.values.qr_base_string}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              sx={{ width: "100%" }}
              label="Qr Base String"
              variant="standard"
            />
          </Grid>

          <Grid item xs={12} sx={{ marginTop: "30px" }}>
            <MDBox component="h4">Mobile Template Qr Dimensions</MDBox>
          </Grid>

          <Grid item xs={12} md={4} sx={{ marginTop: "10px" }}>
            <MDInput
              type="number"
              name="qr_size"
              value={formik.values.qr_size}
              onChange={(e) => {
                const value = e.target.value === "" ? null : Number(e.target.value);
                formik.setFieldValue("qr_size", value);
              }}
              onBlur={formik.handleBlur}
              label="Qr Size"
              sx={{ width: "100%" }}
              variant="standard"
              required
            />
            {formik.touched.qr_size && formik.errors.qr_size && (
              <MDBox sx={{ fontSize: "12px", color: "red", marginTop: "5px" }}>
                {formik.errors.qr_size}
              </MDBox>
            )}
          </Grid>

          <Grid item xs={12} md={4} sx={{ marginTop: "10px" }}>
            <MDInput
              type="number"
              name="qr_x"
              value={formik.values.qr_x}
              onChange={(e) => {
                const value = e.target.value === "" ? null : Number(e.target.value);
                formik.setFieldValue("qr_x", value);
              }}
              onBlur={formik.handleBlur}
              label="Qr Position X (Left To Right)"
              sx={{ width: "100%" }}
              variant="standard"
              required
            />
            {formik.touched.qr_x && formik.errors.qr_x && (
              <MDBox sx={{ fontSize: "12px", color: "red", marginTop: "5px" }}>
                {formik.errors.qr_x}
              </MDBox>
            )}
          </Grid>

          <Grid item xs={12} md={4} sx={{ marginTop: "10px" }}>
            <MDInput
              type="number"
              name="qr_y"
              value={formik.values.qr_y}
              onChange={(e) => {
                const value = e.target.value === "" ? null : Number(e.target.value);
                formik.setFieldValue("qr_y", value);
              }}
              onBlur={formik.handleBlur}
              label="Qr Position Y (Top To Bottom)"
              sx={{ width: "100%" }}
              variant="standard"
              required
            />
            {formik.touched.qr_y && formik.errors.qr_y && (
              <MDBox sx={{ fontSize: "12px", color: "red", marginTop: "5px" }}>
                {formik.errors.qr_y}
              </MDBox>
            )}
          </Grid>

          <Grid item xs={12} sx={{ marginTop: "30px" }}>
            <MDBox component="h4">Desktop Template Qr Dimensions</MDBox>
          </Grid>

          <Grid item xs={12} md={4} sx={{ marginTop: "10px" }}>
            <MDInput
              type="number"
              name="desk_qr_size"
              value={formik.values.desk_qr_size}
              onChange={(e) => {
                const value = e.target.value === "" ? null : Number(e.target.value);
                formik.setFieldValue("desk_qr_size", value);
              }}
              onBlur={formik.handleBlur}
              label="Qr Size"
              sx={{ width: "100%" }}
              variant="standard"
              required
            />
            {formik.touched.desk_qr_size && formik.errors.desk_qr_size && (
              <MDBox sx={{ fontSize: "12px", color: "red", marginTop: "5px" }}>
                {formik.errors.desk_qr_size}
              </MDBox>
            )}
          </Grid>

          <Grid item xs={12} md={4} sx={{ marginTop: "10px" }}>
            <MDInput
              type="number"
              name="desk_qr_x"
              value={formik.values.desk_qr_x}
              onChange={(e) => {
                const value = e.target.value === "" ? null : Number(e.target.value);
                formik.setFieldValue("desk_qr_x", value);
              }}
              onBlur={formik.handleBlur}
              label="Qr Position X (Left To Right)"
              sx={{ width: "100%" }}
              variant="standard"
              required
            />
            {formik.touched.desk_qr_x && formik.errors.desk_qr_x && (
              <MDBox sx={{ fontSize: "12px", color: "red", marginTop: "5px" }}>
                {formik.errors.desk_qr_x}
              </MDBox>
            )}
          </Grid>

          <Grid item xs={12} md={4} sx={{ marginTop: "10px" }}>
            <MDInput
              type="number"
              name="desk_qr_y"
              value={formik.values.desk_qr_y}
              onChange={(e) => {
                const value = e.target.value === "" ? null : Number(e.target.value);
                formik.setFieldValue("desk_qr_y", value);
              }}
              onBlur={formik.handleBlur}
              label="Qr Position Y (Top To Bottom)"
              sx={{ width: "100%" }}
              variant="standard"
              required
            />
            {formik.touched.desk_qr_y && formik.errors.desk_qr_y && (
              <MDBox sx={{ fontSize: "12px", color: "red", marginTop: "5px" }}>
                {formik.errors.desk_qr_y}
              </MDBox>
            )}
          </Grid>
          {/* 
          <Grid item xs={12} md={6} sx={{ marginTop: "10px" }}>
            <MDInput
              type="number"
              name="text_x"
              value={formik.values.text_x}
              onChange={(e) => {
                const value = e.target.value === "" ? 0 : Number(e.target.value);
                formik.setFieldValue("text_x", value);
              }}
              onBlur={formik.handleBlur}
              label="Text Position X (Left To Right)"
              sx={{ width: "100%" }}
              variant="standard"
              required
            />
            {formik.touched.text_x && formik.errors.text_x && (
              <MDBox sx={{ fontSize: "12px", color: "red", marginTop: "5px" }}>
                {formik.errors.text_x}
              </MDBox>
            )}
          </Grid>

          <Grid item xs={12} md={6} sx={{ marginTop: "10px" }}>
            <MDInput
              type="number"
              name="text_y"
              value={formik.values.text_y}
              onChange={(e) => {
                const value = e.target.value === "" ? 0 : Number(e.target.value);
                formik.setFieldValue("text_y", value);
              }}
              onBlur={formik.handleBlur}
              label="Text Position Y (Top To Bottom)"
              sx={{ width: "100%" }}
              variant="standard"
              required
            />
            {formik.touched.text_y && formik.errors.text_y && (
              <MDBox sx={{ fontSize: "12px", color: "red", marginTop: "5px" }}>
                {formik.errors.text_y}
              </MDBox>
            )}
          </Grid> */}

          {/* status */}
          <Grid item xs={12} md={6} sx={{ paddingTop: "50px !important" }}>
            <MDSelectBox
              name="is_active"
              defaultValue={status}
              options={statusData}
              handleChange={(value) => handleStatusChange(value)}
              label="Status"
              width="100%"
              multiple={false}
              onBlur={formik.handleBlur}
              required
            />
            {formik.touched.is_active && formik.errors.is_active && (
              <MDBox sx={{ fontSize: "12px", color: "red", marginTop: "5px" }}>
                {formik.errors.is_active}
              </MDBox>
            )}
          </Grid>
        </Grid>

        <MDBox sx={{ width: "100%", textAlign: "center", marginTop: "40px" }}>
          <SubmitButton btnText={formIsEdit ? "Update" : "Add"} type="submit" />
        </MDBox>
      </MDBox>
      {/* QR Preview Modal */}
      <Modal
        open={isTempView}
        onClose={handleClosePreview}
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <Box
          sx={{
            bgcolor: "background.paper",
            boxShadow: 24,
            p: 4,
            borderRadius: 2,
            maxWidth: "95vw",
            maxHeight: "95vh",
            overflow: "auto",
            outline: "none",
          }}
        >
          <Box
            sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: 2 }}
          >
            <Typography style={{ margin: 0 }}>QR Template Preview</Typography>
            <CloseIcon
              onClick={handleClosePreview}
              sx={{
                cursor: "pointer",
                padding: "6px",
                width: "35px",
                height: "35px",
                borderRadius: "50px",
                transition: "all 0.2s ease-in-out",
                color: `primary`,
              }}
            />
          </Box>

          {isGenerating ? (
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                minHeight: "300px",
              }}
            >
              <CircularProgress />
            </Box>
          ) : previewImage ? (
            <Box>
              <img
                src={previewImage}
                alt="QR Template Preview"
                style={{
                  maxWidth: "100%",
                  maxHeight: "75vh",
                  objectFit: "contain",
                  display: "block",
                  margin: "0 auto",
                  border: "1px solid #ddd",
                }}
              />
            </Box>
          ) : null}
        </Box>
      </Modal>
    </>
  );
};
QrTemplateForm.propTypes = {
  getQrTemplateList: PropTypes.func,
};

export default QrTemplateForm;
